// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--cp-inp-sing-box-sty{
    height: 27px;
    border-radius: 3px;
    border: 1px solid rgba(138, 139, 143, 1);
    outline: none;
    text-align: center;
    color: #8a8b8f;
    transition: all 0.3s;
}

.scl--cp-inp-sing-box-sty:hover{
    color: rgba(0, 0, 0, 0.8);
    border: 1px solid rgba(0, 0, 0, 0.8);
}

.scl--cp-inp-sing-box-sty:focus{
    color: rgba(0, 0, 0, 0.8);
    border: 1px solid rgba(0, 0, 0, 0.8);
    box-shadow: inset 0 -2px 0 0 rgba(35, 136, 255, 1)
}

.scl--cp-inp-sing-box-sty.error{
    border: 1px solid red;
}

.scl--cp-inp-sing-box-sty.error:focus{
    box-shadow: inset 0 -2px 0 0 red
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/input-fs-cp/text-field-op/css/setting-text-field.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;AACJ","sourcesContent":[".scl--cp-inp-sing-box-sty{\n    height: 27px;\n    border-radius: 3px;\n    border: 1px solid rgba(138, 139, 143, 1);\n    outline: none;\n    text-align: center;\n    color: #8a8b8f;\n    transition: all 0.3s;\n}\n\n.scl--cp-inp-sing-box-sty:hover{\n    color: rgba(0, 0, 0, 0.8);\n    border: 1px solid rgba(0, 0, 0, 0.8);\n}\n\n.scl--cp-inp-sing-box-sty:focus{\n    color: rgba(0, 0, 0, 0.8);\n    border: 1px solid rgba(0, 0, 0, 0.8);\n    box-shadow: inset 0 -2px 0 0 rgba(35, 136, 255, 1)\n}\n\n.scl--cp-inp-sing-box-sty.error{\n    border: 1px solid red;\n}\n\n.scl--cp-inp-sing-box-sty.error:focus{\n    box-shadow: inset 0 -2px 0 0 red\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
